// extracted by mini-css-extract-plugin
module.exports = {"wr":"styles_wr__1mBgf","row":"styles_row__2XCdH","mt_30":"styles_mt_30__xl39r"};